import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { useResponseErrors } from "PFCore/helpers/use_response_errors";
import { UnknownError } from "PFTypes";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { ChatAttachmentItem } from "./chat_attachment_input";

export const useChatAttachments = () => {
  const { t } = useTranslation();
  const { showGrowl } = useGrowlStoreActions();
  const { getFirstError } = useResponseErrors();

  const [attachments, setAttachments] = useState<ChatAttachmentItem[]>([]);

  const handleAddAttachment = useCallback((attachment: ChatAttachmentItem) => {
    setAttachments((attachments) => [...attachments, attachment]);
  }, []);

  const handleRemoveAttachment = useCallback((attachment: ChatAttachmentItem) => {
    setAttachments((attachments) => attachments.filter((other) => other !== attachment));
  }, []);

  const handleClearAttachments = useCallback(() => setAttachments([]), []);

  const handleAttachmentSaveFailed = useCallback(
    (error: UnknownError) => {
      // the fallback copy -> most likely a 500
      const message = getFirstError(error) || t("chat.attachmentUploadFailed");
      showGrowl({ message, kind: "error" });
    },
    [getFirstError, showGrowl, t]
  );

  return {
    attachments,
    handleAddAttachment,
    handleRemoveAttachment,
    handleClearAttachments,
    handleAttachmentSaveFailed
  };
};
